// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminNav_root__3zPXp","buttonrow":"AdminNav_buttonrow__2tBup"};